import { inject, provide } from 'vue-demi';

const symbol = Symbol('useTeamworkFeatures');

export function provideTeamworkFeaturesState(teamworkFeaturesState) {
  provide(symbol, teamworkFeaturesState);
  return teamworkFeaturesState;
}

export function useTeamworkFeaturesState() {
  return inject(symbol);
}
